import {
  Box, Container, Flex, Image, Menu, MenuItem, MenuList, Spacer, Tab, TabIndicator, TabList, Tabs,
} from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';

import { Profile } from './Profile';
// import SettingsIcon from 'assets/icons/settings.svg';
import Logo from 'assets/logos/light-logo.svg';
import useUserContext from 'contexts/user/useUserContext';
import { borderRadius, truefilesColor } from 'themes/constants';

export default function Header(): JSX.Element {
  const {
    logout,
    user,
  } = useUserContext();

  const avatar = `https://ui-avatars.com/api/?name=${user!.firstName}${user!.lastName}&format=svg&background=random`;

  return (
    <Container as={Flex} px='22px' pb={['100px', 0]} mt='18px' minW='350px' maxW='1920px' alignItems='center'>
      <Box as={RouterLink} to='/'>
        <Image width='159px' mr='50px' src={Logo} />
      </Box>
      <Tabs
        position='relative'
        variant='unstyled'
        isLazy
        lazyBehavior='unmount'
      >
        <TabList
          gap='50px'
        >
          <Tab
            as={RouterLink}
            px='0px'
            _hover={{ color: 'gray.400' }}
            _selected={{ color: truefilesColor }}
            to='/'
            fontWeight='600'
            fontSize='16px'
          >
            Applications
          </Tab>
        </TabList>
        <TabIndicator
          position='relative'
          mt='0px'
          height='0px'
          bg={truefilesColor}
          _before={{
            content: '""',
            position: 'absolute',
            top: 'auto',
            left: '50%',
            transform: 'translateX(-50%)',
            height: '5px',
            width: '48px !important',
            bg: truefilesColor,
            opacity: '1',
            borderRadius,
            transformOrigin: 'left',
          }}
        />
      </Tabs>
      <Spacer />
      <Menu isLazy>
        <Profile
          displayName={`${user?.firstName} ${user?.lastName}`}
          avatarSrc={avatar}
          email={user?.email}
        />
        {/* <Box as={RouterLink} to='/settings' mx='10px'>
          <img src={SettingsIcon} width='24px' height='24px' />
        </Box> */}
        <MenuList textStyle='paragraphReg'>
          <MenuItem as={RouterLink} to='/settings'>Settings</MenuItem>
          <MenuItem as={RouterLink} to='/' onClick={() => logout()}>Logout</MenuItem>
        </MenuList>
      </Menu>
    </Container>
  );
}
